// extracted by mini-css-extract-plugin
export default {"angle":"Angle_angle__OFMhD"};